var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8516 5.22649L7.76592 1.37133C7.82165 1.25976 7.90735 1.16592 8.01342 1.10033C8.11949 1.03474 8.24174 1 8.36645 1C8.49116 1 8.61341 1.03474 8.71948 1.10033C8.82555 1.16592 8.91125 1.25976 8.96698 1.37133L10.8813 5.22649L15.1609 5.84839C15.2843 5.8655 15.4005 5.91698 15.496 5.99694C15.5916 6.0769 15.6628 6.18213 15.7015 6.30061C15.7401 6.41908 15.7447 6.54604 15.7146 6.66698C15.6846 6.78793 15.6211 6.89799 15.5315 6.9846L12.4353 9.98355L13.1662 14.2204C13.2598 14.7642 12.6851 15.1783 12.1936 14.9219L8.36645 12.9206L4.53855 14.9219C4.04781 15.179 3.47307 14.7642 3.56665 14.2197L4.2976 9.98281L1.20139 6.98386C1.11222 6.89719 1.04915 6.78724 1.01936 6.66651C0.989565 6.54578 0.994238 6.41912 1.03285 6.30091C1.07146 6.18271 1.14245 6.07771 1.23776 5.99784C1.33307 5.91798 1.44888 5.86645 1.57202 5.84912L5.8516 5.22649Z",
    stroke: "#FA5A7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStarIcon);
export default __webpack_public_path__ + "static/media/red-star-icon.129a824779c48cb549b2520155b2ae7b.svg";
export { ForwardRef as ReactComponent };